<!-- 200px expanded; 56px collapsed. 300px when expanded on mobile -->
<div class="menu" [class.collapsed]="config.value.menuCollapsed">
    <app-logo style="width: calc(100% - 8px); height: 40px; gap: 0" [showText]="!config.value.menuCollapsed"></app-logo>

    <!-- <div>
        <mat-icon>new_file</mat-icon>
        <mat-icon>new_folder</mat-icon>
        <mat-icon>sort</mat-icon>
    </div> -->

    <!-- --------- -->
    <hr/>
<!--
    <div (click)="pages.openWorkspace()">Open Workspace</div> -->

    <app-entry-list
        [item]="pages.rootPage"
        [items]="pages.rootPage.children"
        [style.display]="config.value.menuCollapsed ? 'none' : ''"
        style="overflow-y: auto"
    />

    <span style="flex: 1"></span>

    <!-- --------- -->
    <hr/>

    <div class="item"
        [matTooltip]="config.value.menuCollapsed ? 'Expand Dock' : null"
        (click)="config.set('menuCollapsed', !config.value.menuCollapsed)"
    >
        <!-- Overlay search functionality -->

        <span class="icon">
            <mat-icon [fontIcon]="config.value.menuCollapsed ? 'keyboard_double_arrow_right' : 'keyboard_double_arrow_left'"></mat-icon>
        </span>
        <span class="label">Collapse</span>
    </div>

    <div class="item"
        [matTooltip]="config.value.menuCollapsed ? 'Settings' : null"
        [ngx-menu]="profileLinks"
        [ngx-menu-config]="{ position: 'right', alignment: 'end', customClass: ['nav-menu']}"
    >
        <!-- Overlay search functionality -->
        <span class="icon">
            <mat-icon>settings</mat-icon>
        </span>
        <span class="label">Settings</span>
    </div>
</div>

